import { Component, OnInit, OnChanges, Input } from '@angular/core';

@Component({
  selector: 'ad-hoc-filter-select',
  template: require('./adhoc.filter.select.component.html'),
})
export class AdHocFilterSelectComponent implements OnInit, OnChanges {
  @Input() filter: any;

  value: string;

  constructor() { }

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(): void {
    this.init();
  }

  selectedElement(item: any): void {
    this.filter.value = item;
  }

  private init(): void {
    this.value = '';
    if (this.filter.value && this.filter.value.id) {
      this.value = this.filter.value.id;
    }
  }
}
